export function numberWithCommas(x: number | undefined) {
  return typeof x === "number" ? x.toLocaleString("en") : "[no data]";
}

export function numWithSufix(n: number) {
  let s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
